import { render } from "./ListEmpty.vue?vue&type=template&id=fe6c05f6&scoped=true&ts=true"
import script from "./ListEmpty.vue?vue&type=script&lang=ts"
export * from "./ListEmpty.vue?vue&type=script&lang=ts"

import "./ListEmpty.vue?vue&type=style&index=0&id=fe6c05f6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe6c05f6"]])

export default __exports__